import React from 'react';
import classes from './ProblemError.module.scss';

const ProblemError = ({ children }) => {
  return <div className={classes.wrapper}>{children}</div>;
};

export default ProblemError;
